"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Backdrop = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const create_use_styles_1 = __importDefault(require("../../theming/create-use-styles"));
const color_1 = require("../../theming/utils/color");
const portal_1 = __importStar(require("../portal"));
const useStyles = (0, create_use_styles_1.default)(({ colors }) => ({
    backdrop: (transparent) => ({
        "position": "fixed",
        "top": 0,
        "right": 0,
        "bottom": 0,
        "left": 0,
        "zIndex": 1000,
        "display": "block",
        "background": transparent ? "rgba(255, 255, 255, 0.00001)" : (0, color_1.fade)(colors.darkgray, 0.3),
        "& ~ $backdrop": {
            zIndex: 1001,
        },
    }),
}));
function Backdrop({ className, container = portal_1.defaultContainer, transparent = true, ...props }) {
    const classes = useStyles(transparent);
    return (react_1.default.createElement(portal_1.default, { container: container },
        react_1.default.createElement("div", { className: (0, classnames_1.default)(classes.backdrop, className), ...props })));
}
exports.Backdrop = Backdrop;
exports.default = Backdrop;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYmFja2Ryb3AuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9jb21wb25lbnRzL2JhY2tkcm9wL2JhY2tkcm9wLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLGtEQUEwQjtBQUMxQiw0REFBb0M7QUFFcEMsd0ZBQThEO0FBQzlELHFEQUFpRDtBQUVqRCxvREFBcUQ7QUFPckQsTUFBTSxTQUFTLEdBQUcsSUFBQSwyQkFBZSxFQUFDLENBQUMsRUFBRSxNQUFNLEVBQUUsRUFBRSxFQUFFLENBQUMsQ0FBQztJQUNqRCxRQUFRLEVBQUUsQ0FBQyxXQUFvQixFQUFFLEVBQUUsQ0FBQyxDQUFDO1FBQ25DLFVBQVUsRUFBRSxPQUFPO1FBQ25CLEtBQUssRUFBRSxDQUFDO1FBQ1IsT0FBTyxFQUFFLENBQUM7UUFDVixRQUFRLEVBQUUsQ0FBQztRQUNYLE1BQU0sRUFBRSxDQUFDO1FBQ1QsUUFBUSxFQUFFLElBQUk7UUFDZCxTQUFTLEVBQUUsT0FBTztRQUNsQixZQUFZLEVBQUUsV0FBVyxDQUFDLENBQUMsQ0FBQyw4QkFBOEIsQ0FBQyxDQUFDLENBQUMsSUFBQSxZQUFJLEVBQUMsTUFBTSxDQUFDLFFBQVEsRUFBRSxHQUFHLENBQUM7UUFFdkYsZUFBZSxFQUFFO1lBQ2YsTUFBTSxFQUFFLElBQUk7U0FDYjtLQUNGLENBQUM7Q0FDSCxDQUFDLENBQUMsQ0FBQztBQUVKLFNBQWdCLFFBQVEsQ0FBQyxFQUFFLFNBQVMsRUFBRSxTQUFTLEdBQUcseUJBQWdCLEVBQUUsV0FBVyxHQUFHLElBQUksRUFBRSxHQUFHLEtBQUssRUFBaUI7SUFDL0csTUFBTSxPQUFPLEdBQUcsU0FBUyxDQUFDLFdBQVcsQ0FBQyxDQUFDO0lBRXZDLE9BQU8sQ0FDTCw4QkFBQyxnQkFBTSxJQUFDLFNBQVMsRUFBRSxTQUFTO1FBQzFCLHVDQUFLLFNBQVMsRUFBRSxJQUFBLG9CQUFVLEVBQUMsT0FBTyxDQUFDLFFBQVEsRUFBRSxTQUFTLENBQUMsS0FBTSxLQUFLLEdBQUksQ0FDL0QsQ0FDVixDQUFDO0FBQ0osQ0FBQztBQVJELDRCQVFDO0FBRUQsa0JBQWUsUUFBUSxDQUFDIn0=